<template>
    <div class="lawlex-custom-card">
      <div class="user-not-registered-wraper">
        <img src="@/img/lawlex_lock.svg"/>
        <div>
          {{ $t('msg_user_not_registered') }}<br/><br/>
          {{ $t('msg_user_not_registered_click') }} <a href="javascript:void(0)" class="link" @click="handleClick">{{ $t('msg_user_not_registered_here') }}</a> {{ $t('msg_user_not_registered_register') }}.
        </div>
      </div>
    </div>
  </template>

  <script>
  import { createNamespacedHelpers } from "vuex";
  const { mapActions } = createNamespacedHelpers('quickviews');
  export default {
    name: "UserNotRegistered",
    methods: {
    ...mapActions(
      [
        'redirectToLawlexUrl'
      ]
    ),
    handleClick() {
      const module = 'Lawlex - UserNotRegistered';
      const url = '';
      this.redirectToLawlexUrl({url, module});
    }
  }
  };
  </script>
